import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../config/firebase";

const C = {
  bg:     "#F8F6F1",
  forest: "#2D5A3D",
  dark:   "#1C3A28",
  terra:  "#C4622D",
  text:   "#1C1C1E",
  muted:  "#8A8A8E",
  border: "#D3D1C7",
};

function fmt(n) {
  return Number(n || 0).toFixed(2).replace(".", ",") + " €";
}

export default function CertificatPublicScreen({ certId }) {
  const [cert,    setCert]    = useState(null);
  const [factures,setFactures]= useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [viewImg, setViewImg] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const snap = await getDoc(doc(db, "certificats", certId));
        if (!snap.exists()) { setError("Certificat introuvable."); return; }
        const data = snap.data();
        setCert(data);
        console.log("[Certificat] champs reçus:", Object.keys(data));
        console.log("[Certificat] factures_garage:", Array.isArray(data.factures_garage) ? data.factures_garage.length + " photo(s)" : "absent");
        if (Array.isArray(data.factures_garage) && data.factures_garage.length > 0) {
          setFactures(data.factures_garage);
        }
      } catch {
        setError("Erreur lors du chargement du certificat.");
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [certId]);

  if (loading) {
    return (
      <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "-apple-system, 'SF Pro Display', sans-serif" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🚐</div>
          <div style={{ fontSize: 14, color: C.muted }}>Chargement du certificat…</div>
        </div>
      </div>
    );
  }

  if (error || !cert) {
    return (
      <div style={{ minHeight: "100vh", background: C.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "-apple-system, 'SF Pro Display', sans-serif" }}>
        <div style={{ textAlign: "center", padding: "0 32px" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>❌</div>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.terra }}>{error || "Certificat introuvable."}</div>
        </div>
      </div>
    );
  }

  const interventions = cert.interventionsList || [];

  return (
    <div style={{
      maxWidth: 430, margin: "0 auto", minHeight: "100vh",
      background: C.bg, paddingBottom: 40,
      fontFamily: "-apple-system, 'SF Pro Display', 'Segoe UI', sans-serif",
      color: C.text,
    }}>

      {/* Header */}
      <div style={{ background: `linear-gradient(160deg, ${C.dark}, ${C.forest})`, padding: "28px 20px 22px" }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: "rgba(248,246,241,0.5)", letterSpacing: 1.5, marginBottom: 6 }}>
          CHECKVAN · CERTIFICAT PUBLIC
        </div>
        <div style={{ fontSize: 26, fontWeight: 900, color: "#F8F6F1", lineHeight: 1.1 }}>
          {cert.vanNom || "Véhicule"}
        </div>
        {cert.vanImmat && (
          <div style={{ fontSize: 13, color: "rgba(248,246,241,0.65)", letterSpacing: 2, marginTop: 6, fontWeight: 700 }}>
            {cert.vanImmat}
          </div>
        )}
        <div style={{ marginTop: 14, fontSize: 10, color: "rgba(248,246,241,0.4)", letterSpacing: 1 }}>
          {certId}
        </div>
      </div>

      <div style={{ padding: "16px 16px 0" }}>

        {/* Stats */}
        <div style={{ background: "white", borderRadius: 14, padding: 16, marginBottom: 12, boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: `1px solid ${C.border}` }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: 1, marginBottom: 12 }}>STATISTIQUES</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 13, color: C.muted }}>Vérifications effectuées</span>
              <span style={{ fontSize: 13, fontWeight: 800, color: C.text }}>{cert.verifications ?? "—"}</span>
            </div>
            <div style={{ height: 1, background: C.border }} />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 13, color: C.muted }}>Interventions enregistrées</span>
              <span style={{ fontSize: 13, fontWeight: 800, color: C.text }}>{cert.interventions ?? "—"}</span>
            </div>
            {cert.updatedAt && (
              <>
                <div style={{ height: 1, background: C.border }} />
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 13, color: C.muted }}>Dernière mise à jour</span>
                  <span style={{ fontSize: 13, fontWeight: 800, color: C.text }}>
                    {new Date(cert.updatedAt).toLocaleDateString("fr-FR")}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Historique garage */}
        {interventions.length > 0 && (
          <div style={{ background: "white", borderRadius: 14, padding: 16, marginBottom: 12, boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: `1px solid ${C.border}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: 1, marginBottom: 12 }}>
              HISTORIQUE GARAGE
            </div>
            {interventions.map((item, i) => (
              <div key={i} style={{
                paddingBottom: 12, marginBottom: 12,
                borderBottom: i < interventions.length - 1 ? `1px solid ${C.border}` : "none",
              }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: C.text, flex: 1 }}>
                    {item.description || "Intervention"}
                  </div>
                  {item.cout > 0 && (
                    <div style={{ fontSize: 13, fontWeight: 800, color: C.terra, marginLeft: 8 }}>
                      {fmt(item.cout)}
                    </div>
                  )}
                </div>
                <div style={{ fontSize: 11, color: C.muted, marginTop: 3 }}>
                  {item.date ? new Date(item.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : ""}
                  {item.km ? ` · ${Math.round(Number(item.km)).toLocaleString("fr-FR")} km` : ""}
                </div>
              </div>
            ))}
          </div>
        )}

        {interventions.length === 0 && (
          <div style={{ background: "white", borderRadius: 14, padding: "20px 16px", marginBottom: 12, boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: `1px solid ${C.border}`, textAlign: "center" }}>
            <div style={{ fontSize: 13, color: C.muted, fontStyle: "italic" }}>Aucune intervention enregistrée.</div>
          </div>
        )}

        {/* Factures Garage */}
        {factures.length > 0 && (
          <div style={{ background: "white", borderRadius: 14, padding: 16, marginBottom: 12, boxShadow: "0 1px 8px rgba(0,0,0,0.06)", border: `1px solid ${C.border}` }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.muted, letterSpacing: 1, marginBottom: 12 }}>
              FACTURES GARAGE ({factures.length})
            </div>

            {/* Modal plein écran */}
            {viewImg && (
              <div
                onClick={() => setViewImg(null)}
                style={{ position: "fixed", inset: 0, zIndex: 999, background: "rgba(0,0,0,0.92)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
              >
                <div onClick={e => e.stopPropagation()} style={{ position: "relative", maxWidth: 400, width: "100%" }}>
                  {viewImg.date && (
                    <div style={{ background: C.dark, borderRadius: "12px 12px 0 0", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: 13, fontWeight: 800, color: "#F8F6F1" }}>Garage</span>
                      <span style={{ fontSize: 12, color: "rgba(248,246,241,0.65)" }}>
                        {new Date(viewImg.date).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" })}
                      </span>
                    </div>
                  )}
                  <img
                    src={viewImg.image}
                    alt="Facture Garage"
                    style={{ width: "100%", display: "block", borderRadius: viewImg.date ? "0 0 12px 12px" : 12 }}
                  />
                  <button
                    onClick={() => setViewImg(null)}
                    style={{ position: "absolute", top: -14, right: -14, background: "white", border: "none", borderRadius: "50%", width: 32, height: 32, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.35)" }}
                  >✕</button>
                </div>
              </div>
            )}

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
              {factures.map(f => (
                <button
                  key={f.factureId}
                  onClick={() => setViewImg(f)}
                  style={{ padding: 0, border: "none", borderRadius: 10, overflow: "hidden", cursor: "pointer", position: "relative", background: C.border, display: "block" }}
                >
                  <img src={f.image} alt="" style={{ width: "100%", height: 130, objectFit: "cover", display: "block" }} />
                  <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "linear-gradient(transparent, rgba(0,0,0,0.7))", padding: "18px 8px 7px" }}>
                    {f.date && (
                      <div style={{ fontSize: 10, color: "white", fontWeight: 700 }}>
                        {new Date(f.date).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit" })}
                      </div>
                    )}
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Tampon */}
        <div style={{
          background: "#EAF3DE", border: "1.5px solid #5DCAA5",
          borderRadius: 14, padding: "16px 20px",
          display: "flex", alignItems: "center", gap: 14, marginBottom: 12,
        }}>
          <div style={{ width: 36, height: 36, borderRadius: "50%", background: C.forest, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <span style={{ color: "white", fontSize: 18 }}>✓</span>
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 800, color: "#085041" }}>CERTIFIÉ CHECKVAN</div>
            <div style={{ fontSize: 11, color: "#085041", opacity: 0.7, marginTop: 2 }}>{certId}</div>
          </div>
        </div>

        <div style={{ textAlign: "center", fontSize: 11, color: C.muted, marginTop: 8 }}>
          Généré par CheckVan · checkvan.checkapp-studio.fr
        </div>

      </div>
    </div>
  );
}
